<template>
  <div :id="chartId"></div>
</template>
<script lang="ts" setup>
import * as echarts from "echarts/core"
import { nextTick, onMounted, onUnmounted, watch } from "vue"
import { v4 as uuid } from "uuid"
import { EChartsOption } from "echarts"

const props = defineProps<{
  option: EChartsOption
  version: string
}>()

const chartId = uuid()
let chart = null as echarts.ECharts | null
let resizeObserver: ResizeObserver | null = null

const render = async () => {
  try {
    const option = props.option
    renderChart(option)
  } catch (error) {
    console.error("Failed to get chart option:", error)
  }
}

const initResizeObserver = () => {
  const container = document.getElementById(chartId)
  if (!container || !chart) return

  resizeObserver = new ResizeObserver((entries) => {
    requestAnimationFrame(() => {
      if (!resizeObserver || !chart) return
      for (const entry of entries) {
        const { width, height } = entry.contentRect
        if (width > 0 && height > 0 && chart) {
          chart.resize()
        }
      }
    })
  })

  resizeObserver.observe(container)
}

const renderChart = async (option: EChartsOption) => {
  disposeChart()
  await nextTick()
  const container = document.getElementById(chartId)
  if (!container) {
    return
  }

  chart = echarts.init(container)
  chart.setOption(option)
  initResizeObserver()
}

const disposeChart = () => {
  if (chart) {
    chart.dispose()
    chart = null
  }
  if (resizeObserver) {
    resizeObserver.disconnect()
    resizeObserver = null
  }
}

onUnmounted(() => {
  disposeChart()
})

watch(
  () => props.version,
  () => {
    render()
  }
)
</script>
